import { createSvgIcon } from '@mui/material/utils';

export const StrokeIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1872 5.31295C18.3825 5.50821 18.3825 5.8248 18.1872 6.02006L9.28056 14.9267C8.59723 15.61 7.48936 15.6101 6.80591 14.9269L1.8135 9.93627C1.6182 9.74104 1.61815 9.42446 1.81338 9.22916C2.0086 9.03387 2.32519 9.03381 2.52048 9.22904L7.51289 14.2197C7.8058 14.5125 8.2806 14.5125 8.57346 14.2196L17.4801 5.31295C17.6754 5.11769 17.9919 5.11769 18.1872 5.31295Z"
      fill="white"
    />
  </svg>,
  'Stroke'
);

export const WriteIcon = createSvgIcon(
  <svg width="14" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.38981 8.91395L9.5869 0.716801C9.87596 0.42774 10.3446 0.427732 10.6337 0.716784L13.2835 3.36645C13.5726 3.65552 13.5726 4.12421 13.2835 4.41329L5.08647 12.6104C4.9884 12.7085 4.86476 12.777 4.72964 12.8082L1.86133 13.4707C1.06171 13.6554 0.344987 12.9386 0.529645 12.139L1.19199 9.27081C1.22319 9.13567 1.29174 9.01202 1.38981 8.91395ZM1.504 12.364L2.14959 9.56838L10.1103 1.60761L12.3927 3.88988L4.43202 11.8506L1.63629 12.4963C1.55689 12.5147 1.48565 12.4435 1.504 12.364Z"
      fill="#5B5C5B"
    />
    <path
      d="M0.833496 14.4998C0.557354 14.4998 0.333496 14.7237 0.333496 14.9998C0.333496 15.276 0.557354 15.4998 0.833496 15.4998H13.1668C13.443 15.4998 13.6668 15.276 13.6668 14.9998C13.6668 14.7237 13.443 14.4998 13.1668 14.4998H0.833496Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Write'
);
export const CopyIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9165 1.25C6.53579 1.25 5.4165 2.36929 5.4165 3.75C4.03579 3.75 2.9165 4.86929 2.9165 6.25V16.25C2.9165 17.6307 4.03579 18.75 5.41651 18.75H12.0832C13.4639 18.75 14.5832 17.6307 14.5832 16.25C15.9639 16.25 17.0832 15.1307 17.0832 13.75V3.75C17.0832 2.36929 15.9639 1.25 14.5832 1.25H7.9165ZM14.5832 15.25C15.4116 15.25 16.0832 14.5784 16.0832 13.75V3.75C16.0832 2.92157 15.4116 2.25 14.5832 2.25H7.9165C7.08808 2.25 6.4165 2.92157 6.4165 3.75H12.0832C13.4639 3.75 14.5832 4.86929 14.5832 6.25V15.25ZM3.9165 6.25C3.9165 5.42157 4.58808 4.75 5.4165 4.75H12.0832C12.9116 4.75 13.5832 5.42157 13.5832 6.25V16.25C13.5832 17.0784 12.9116 17.75 12.0832 17.75H5.41651C4.58808 17.75 3.9165 17.0784 3.9165 16.25V6.25Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Copy'
);

export const DeleteIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33341 7.41642C8.60956 7.41642 8.83341 7.64028 8.83341 7.91642V14.1664C8.83341 14.4426 8.60956 14.6664 8.33341 14.6664C8.05727 14.6664 7.83342 14.4426 7.83342 14.1664L7.83341 7.91642C7.83341 7.64028 8.05727 7.41642 8.33341 7.41642Z"
      fill="#5B5C5B"
    />
    <path
      d="M12.1667 7.91642C12.1667 7.64028 11.9429 7.41642 11.6667 7.41642C11.3906 7.41642 11.1667 7.64028 11.1667 7.91642V14.1664C11.1667 14.4426 11.3906 14.6664 11.6667 14.6664C11.9429 14.6664 12.1667 14.4426 12.1667 14.1664L12.1667 7.91642Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0835 2.9165C7.0835 2.22615 7.64314 1.6665 8.3335 1.6665H11.6668C12.3572 1.6665 12.9168 2.22615 12.9168 2.9165V3.99988L16.1668 3.99988C16.443 3.99988 16.6668 4.22373 16.6668 4.49988C16.6668 4.77602 16.443 4.99988 16.1668 4.99988H15.8335V15.6665C15.8335 17.0473 14.7142 18.1665 13.3335 18.1665H6.66683C5.28612 18.1665 4.16683 17.0473 4.16683 15.6665V4.99988H3.8335C3.55735 4.99988 3.3335 4.77602 3.3335 4.49988C3.3335 4.22374 3.55735 3.99988 3.8335 3.99988H7.0835V2.9165ZM8.3335 2.6665H11.6668C11.8049 2.6665 11.9168 2.77843 11.9168 2.9165V3.99984H8.0835V2.9165C8.0835 2.77843 8.19542 2.6665 8.3335 2.6665ZM5.16683 4.99988H14.8335V15.6665C14.8335 16.495 14.1619 17.1665 13.3335 17.1665H6.66683C5.8384 17.1665 5.16683 16.495 5.16683 15.6665V4.99988Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Delete'
);

export const PlusIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.59961 14.2668C7.59961 14.4877 7.7787 14.6668 7.99961 14.6668C8.22052 14.6668 8.39961 14.4877 8.39961 14.2668V8.4001H14.2663C14.4873 8.4001 14.6663 8.22101 14.6663 8.0001C14.6663 7.77918 14.4873 7.6001 14.2663 7.6001H8.39961V1.7335C8.39961 1.51258 8.22052 1.3335 7.99961 1.3335C7.7787 1.3335 7.59961 1.51258 7.59961 1.7335V7.6001H1.73301C1.51209 7.6001 1.33301 7.77918 1.33301 8.0001C1.33301 8.22101 1.51209 8.4001 1.73301 8.4001H7.59961V14.2668Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Plus'
);

export const MinusIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33301 8.0001C1.33301 7.77918 1.51209 7.6001 1.73301 7.6001L14.2663 7.6001C14.4873 7.6001 14.6663 7.77918 14.6663 8.0001C14.6663 8.22101 14.4873 8.4001 14.2663 8.4001H1.73301C1.51209 8.4001 1.33301 8.22101 1.33301 8.0001Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Minus'
);

export const ExcelUploadIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.72139 7.76925C5.68553 7.82216 5.68553 7.89166 5.72139 7.94457L7.06472 9.92613C7.13492 10.0297 7.06094 10.1697 6.93606 10.1697H5.96832C5.9168 10.1697 5.86862 10.1442 5.83966 10.1014L5.11868 9.03778C5.05695 8.94671 4.92307 8.94671 4.86135 9.03778L4.14036 10.1014C4.1114 10.1442 4.06322 10.1697 4.0117 10.1697H3.04396C2.91908 10.1697 2.84511 10.0297 2.9153 9.92613L4.25863 7.94457C4.29449 7.89166 4.29449 7.82216 4.25863 7.76925L2.9153 5.78769C2.84511 5.68415 2.91908 5.54408 3.04396 5.54408H4.0117C4.06322 5.54408 4.1114 5.56966 4.14036 5.61238L4.86135 6.67605C4.92307 6.76711 5.05695 6.76711 5.11868 6.67605L5.83966 5.61238C5.86862 5.56966 5.9168 5.54408 5.96832 5.54408H6.93606C7.06094 5.54408 7.13492 5.68415 7.06472 5.78769L5.72139 7.76925Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.57477 2.49334C1.24193 2.554 1 2.84462 1 3.18377V12.5756C1 12.9148 1.24193 13.2054 1.57477 13.2661L7.8747 14.4144C8.30438 14.4927 8.69991 14.1618 8.69991 13.724V2.03545C8.69991 1.59762 8.30438 1.2667 7.8747 1.34502L1.57477 2.49334ZM7.99991 2.03545L1.69999 3.18377V12.5756L7.99991 13.724V2.03545Z"
      fill="#5B5C5B"
    />
    <g clipPath="url(#clip0_108_18736)">
      <path
        d="M5.72139 8.89725C5.68553 8.84434 5.68553 8.77484 5.72139 8.72193L7.06472 6.74037C7.13491 6.63683 7.06094 6.49676 6.93606 6.49676H5.96832C5.9168 6.49676 5.86862 6.52234 5.83966 6.56506L5.11867 7.62873C5.05695 7.71979 4.92307 7.71979 4.86135 7.62873L4.14036 6.56506C4.1114 6.52234 4.06322 6.49676 4.0117 6.49676H3.04396C2.91908 6.49676 2.84511 6.63683 2.9153 6.74037L4.25863 8.72193C4.29449 8.77484 4.29449 8.84434 4.25863 8.89725L2.9153 10.8788C2.84511 10.9823 2.91908 11.1224 3.04396 11.1224H4.0117C4.06322 11.1224 4.1114 11.0968 4.14036 11.0541L4.86135 9.99046C4.92307 9.89939 5.05695 9.89939 5.11867 9.99046L5.83966 11.0541C5.86862 11.0968 5.9168 11.1224 5.96832 11.1224H6.93606C7.06094 11.1224 7.13491 10.9823 7.06472 10.8788L5.72139 8.89725Z"
        fill="#5B5C5B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.57477 14.1732C1.24193 14.1125 1 13.8219 1 13.4827V4.09087C1 3.75172 1.24193 3.4611 1.57477 3.40043L7.8747 2.25212C8.30438 2.1738 8.6999 2.50472 8.6999 2.94255V14.6311C8.6999 15.0689 8.30438 15.3998 7.8747 15.3215L1.57477 14.1732ZM7.99991 14.6311L1.69999 13.4827V4.09087L7.99991 2.94255V14.6311Z"
        fill="#5B5C5B"
      />
      <path
        d="M10.1001 13.1685H11.4999L11.5 9.01723H12.1999V13.292C12.1999 13.4453 12.1409 13.5924 12.0359 13.7009C11.9309 13.8093 11.7884 13.8702 11.6399 13.8702H9.40007V6.21023H10.1001V13.1685Z"
        fill="#5B5C5B"
      />
      <path
        d="M11.9493 2.11799C12.0837 1.96023 12.3164 1.96023 12.4508 2.11799L14.9115 5.0075C15.1089 5.23926 14.9545 5.61049 14.6608 5.61049H13.2156V7.95477C13.2156 8.15396 13.0641 8.31543 12.8771 8.31543H11.523C11.336 8.31543 11.1844 8.15396 11.1844 7.95477V5.61049H9.73927C9.44553 5.61049 9.29118 5.23926 9.48855 5.0075L11.9493 2.11799Z"
        fill="#5B5C5B"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_18736">
        <rect width="7" height="16" fill="white" transform="matrix(1 0 0 -1 9 16)" />
      </clipPath>
    </defs>
  </svg>,
  'ExcelUp'
);

export const ExcelDownIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.72139 7.76925C5.68553 7.82216 5.68553 7.89166 5.72139 7.94457L7.06472 9.92613C7.13491 10.0297 7.06094 10.1697 6.93606 10.1697H5.96832C5.9168 10.1697 5.86862 10.1442 5.83966 10.1014L5.11867 9.03778C5.05695 8.94671 4.92307 8.94671 4.86135 9.03778L4.14036 10.1014C4.1114 10.1442 4.06322 10.1697 4.0117 10.1697H3.04396C2.91908 10.1697 2.84511 10.0297 2.9153 9.92613L4.25863 7.94457C4.29449 7.89166 4.29449 7.82216 4.25863 7.76925L2.9153 5.78769C2.84511 5.68415 2.91908 5.54408 3.04396 5.54408H4.0117C4.06322 5.54408 4.1114 5.56966 4.14036 5.61238L4.86135 6.67605C4.92307 6.76711 5.05695 6.76711 5.11867 6.67605L5.83966 5.61238C5.86862 5.56966 5.9168 5.54408 5.96832 5.54408H6.93606C7.06094 5.54408 7.13491 5.68415 7.06472 5.78769L5.72139 7.76925Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.57477 2.49334C1.24193 2.554 1 2.84462 1 3.18377V12.5756C1 12.9148 1.24193 13.2054 1.57477 13.2661L7.8747 14.4144C8.30438 14.4927 8.6999 14.1618 8.6999 13.724V2.03545C8.6999 1.59762 8.30438 1.2667 7.8747 1.34502L1.57477 2.49334ZM7.99991 2.03545L1.69999 3.18377V12.5756L7.99991 13.724V2.03545Z"
      fill="#5B5C5B"
    />
    <path
      d="M10.1001 3.49805H11.4999L11.5 7.64927H12.1999V3.3745C12.1999 3.22115 12.1409 3.07408 12.0359 2.96565C11.9309 2.85721 11.7884 2.7963 11.6399 2.7963H9.40007V10.4563H10.1001V3.49805Z"
      fill="#5B5C5B"
    />
    <path
      d="M11.9493 14.5485C12.0837 14.7063 12.3164 14.7063 12.4508 14.5485L14.9115 11.659C15.1089 11.4272 14.9545 11.056 14.6608 11.056H13.2156V8.71173C13.2156 8.51255 13.0641 8.35108 12.8771 8.35108H11.523C11.336 8.35108 11.1844 8.51255 11.1844 8.71173V11.056H9.73927C9.44553 11.056 9.29118 11.4272 9.48855 11.659L11.9493 14.5485Z"
      fill="#5B5C5B"
    />
  </svg>,
  'ExcelDown'
);

export const RefreshIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="-2 -1  18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.30192 3.71767C4.20628 2.71327 5.4054 2.02096 6.72741 1.73996C8.04943 1.45895 9.42646 1.60369 10.6612 2.15341C11.8959 2.70313 12.9248 3.62963 13.6006 4.8001C13.7111 4.99142 13.6455 5.23606 13.4542 5.34651C13.2629 5.45697 13.0182 5.39142 12.9078 5.2001C12.3165 4.17594 11.4161 3.36526 10.3358 2.88425C9.25541 2.40324 8.0505 2.2766 6.89374 2.52248C5.73698 2.76835 4.68775 3.37412 3.89644 4.25297C3.10512 5.13182 2.61234 6.23862 2.48873 7.41474C2.46563 7.63445 2.26881 7.79383 2.04911 7.77074C1.8294 7.74765 1.67002 7.55082 1.69311 7.33112C1.83438 5.98698 2.39756 4.72206 3.30192 3.71767ZM2.66201 10.6536C2.85333 10.5432 3.09796 10.6087 3.20842 10.8C3.79972 11.8242 4.70007 12.6349 5.78044 13.1159C6.8608 13.5969 8.0657 13.7235 9.22247 13.4777C10.3792 13.2318 11.4285 12.626 12.2198 11.7472C13.0111 10.8683 13.5039 9.76152 13.6275 8.5854C13.6506 8.36569 13.8474 8.20631 14.0671 8.2294C14.2868 8.25249 14.4462 8.44931 14.4231 8.66902C14.2818 10.0132 13.7186 11.2781 12.8143 12.2825C11.9099 13.2869 10.7108 13.9792 9.38879 14.2602C8.06678 14.5412 6.68974 14.3965 5.45505 13.8467C4.22035 13.297 3.19137 12.3705 2.5156 11.2C2.40514 11.0087 2.47069 10.7641 2.66201 10.6536Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6614 5.34215C10.6959 5.12396 10.9008 4.97509 11.119 5.00965L13.2542 5.34782C13.3996 5.37086 13.5362 5.27162 13.5593 5.12615L13.8974 2.99101C13.932 2.77281 14.1369 2.62395 14.3551 2.65851C14.5733 2.69307 14.7222 2.89796 14.6876 3.11616L14.3494 5.2513C14.2573 5.83315 13.7109 6.23013 13.129 6.13797L10.9939 5.7998C10.7757 5.76524 10.6268 5.56034 10.6614 5.34215Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.58358 11.0754C5.5264 11.2888 5.30707 11.4154 5.09368 11.3583L3.00558 10.7988C2.86332 10.7606 2.7171 10.8451 2.67898 10.9873L2.11948 13.0754C2.0623 13.2888 1.84297 13.4154 1.62958 13.3583C1.41619 13.3011 1.28956 13.0817 1.34674 12.8684L1.90624 10.7803C2.05871 10.2112 2.64361 9.87354 3.21264 10.026L5.30074 10.5855C5.51412 10.6427 5.64076 10.862 5.58358 11.0754Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Refresh'
);

export const RecycleIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99967 3.0835C6.17971 3.0835 3.08301 6.18019 3.08301 10.0002C3.08301 13.8201 6.17971 16.9168 9.99967 16.9168C13.6727 16.9168 16.6773 14.0535 16.9027 10.4376C16.9199 10.162 17.1573 9.95248 17.4329 9.96966C17.7085 9.98684 17.918 10.2242 17.9008 10.4998C17.6428 14.6395 14.2041 17.9168 9.99967 17.9168C5.62742 17.9168 2.08301 14.3724 2.08301 10.0002C2.08301 5.62791 5.62742 2.0835 9.99967 2.0835C12.9137 2.0835 15.4594 3.6582 16.8332 6.00068C16.9729 6.23888 16.893 6.54523 16.6548 6.68492C16.4166 6.82462 16.1103 6.74476 15.9706 6.50656C14.7689 4.45753 12.5445 3.0835 9.99967 3.0835Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5689 2.23836C17.8435 2.26723 18.0428 2.51326 18.0139 2.78789L17.6655 6.10296C17.5885 6.83531 16.9324 7.36659 16.2001 7.28962L12.885 6.94119C12.6104 6.91233 12.4111 6.6663 12.44 6.39167C12.4689 6.11704 12.7149 5.9178 12.9895 5.94667L16.3046 6.2951C16.4877 6.31434 16.6517 6.18152 16.671 5.99843L17.0194 2.68336C17.0482 2.40873 17.2943 2.2095 17.5689 2.23836Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Recycle'
);

export const SearchWhiteIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3929 14.0997C12.1497 15.1796 10.5263 15.8332 8.75033 15.8332C4.83831 15.8332 1.66699 12.6619 1.66699 8.74984C1.66699 4.83782 4.83831 1.6665 8.75033 1.6665C12.6623 1.6665 15.8337 4.83782 15.8337 8.74984C15.8337 10.5259 15.18 12.1494 14.1 13.3926L18.187 17.4796C18.3823 17.6749 18.3823 17.9914 18.187 18.1867C17.9917 18.382 17.6751 18.382 17.4799 18.1867L13.3929 14.0997ZM14.8337 8.74984C14.8337 12.1096 12.1101 14.8332 8.75033 14.8332C5.39059 14.8332 2.66699 12.1096 2.66699 8.74984C2.66699 5.39011 5.39059 2.6665 8.75033 2.6665C12.1101 2.6665 14.8337 5.39011 14.8337 8.74984Z"
      fill="currentColor"
      // stroke="white"
      // strokeWidth="0.4"
      strokeLinecap="round"
    />
  </svg>,
  'Search'
);
export const SearchBlackIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3929 14.0997C12.1497 15.1796 10.5263 15.8332 8.75033 15.8332C4.83831 15.8332 1.66699 12.6619 1.66699 8.74984C1.66699 4.83782 4.83831 1.6665 8.75033 1.6665C12.6623 1.6665 15.8337 4.83782 15.8337 8.74984C15.8337 10.5259 15.18 12.1494 14.1 13.3926L18.187 17.4796C18.3823 17.6749 18.3823 17.9914 18.187 18.1867C17.9917 18.382 17.6751 18.382 17.4799 18.1867L13.3929 14.0997ZM14.8337 8.74984C14.8337 12.1096 12.1101 14.8332 8.75033 14.8332C5.39059 14.8332 2.66699 12.1096 2.66699 8.74984C2.66699 5.39011 5.39059 2.6665 8.75033 2.6665C12.1101 2.6665 14.8337 5.39011 14.8337 8.74984Z"
      fill="#1f1f1f"
      // stroke="white"
      // strokeWidth="0.4"
      strokeLinecap="round"
    />
  </svg>,
  'Search'
);

export const DetailIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50172 12.9771C9.78589 13.2297 10.2141 13.2297 10.4983 12.9771L17.1678 7.04858C17.3742 6.86512 17.6902 6.88371 17.8737 7.0901C18.0572 7.29649 18.0386 7.61253 17.8322 7.79599L11.1626 13.7245C10.4996 14.3138 9.50041 14.3138 8.83736 13.7245L2.16781 7.79599C1.96142 7.61253 1.94283 7.29649 2.12629 7.0901C2.30975 6.88371 2.62579 6.86512 2.83218 7.04858L9.50172 12.9771Z"
      fill="white"
    />
  </svg>,
  'Detail'
);

export const CalendarIcon = createSvgIcon(
  // <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <svg width="13" height="13" viewBox="-3 -3 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6 9.73331L10.5954 9.73331C10.3744 9.73331 10.1953 9.55423 10.1953 9.33331C10.1953 9.1124 10.3744 8.93331 10.5953 8.93331L11.6 8.93331C11.8209 8.93331 12 9.1124 12 9.33331C12 9.55422 11.8209 9.73331 11.6 9.73331Z"
      fill="#1F1F1F"
    />
    <path
      d="M8.58605 9.73331L7.41395 9.73331C7.19304 9.73332 7.01395 9.55423 7.01395 9.33332C7.01395 9.1124 7.19304 8.93332 7.41395 8.93331L8.58605 8.93331C8.80696 8.93331 8.98605 9.1124 8.98605 9.33331C8.98605 9.55423 8.80696 9.73331 8.58605 9.73331Z"
      fill="#1F1F1F"
    />
    <path
      d="M5.40465 9.73332L4.4 9.73332C4.17909 9.73332 4 9.55423 4 9.33332C4 9.11241 4.17909 8.93332 4.4 8.93332L5.40465 8.93332C5.62556 8.93332 5.80465 9.1124 5.80465 9.33332C5.80465 9.55423 5.62557 9.73332 5.40465 9.73332Z"
      fill="#1F1F1F"
    />
    <path
      d="M7.41395 11.7333L8.58605 11.7333C8.80696 11.7333 8.98605 11.5542 8.98605 11.3333C8.98605 11.1124 8.80696 10.9333 8.58605 10.9333L7.41395 10.9333C7.19304 10.9333 7.01395 11.1124 7.01395 11.3333C7.01395 11.5542 7.19304 11.7333 7.41395 11.7333Z"
      fill="#1F1F1F"
    />
    <path
      d="M4.4 11.7333L5.40465 11.7333C5.62557 11.7333 5.80465 11.5542 5.80465 11.3333C5.80465 11.1124 5.62556 10.9333 5.40465 10.9333L4.4 10.9333C4.17909 10.9333 4 11.1124 4 11.3333C4 11.5542 4.17909 11.7333 4.4 11.7333Z"
      fill="#1F1F1F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.73327 1.73337C5.73327 1.51246 5.55418 1.33337 5.33327 1.33337C5.11235 1.33337 4.93327 1.51246 4.93327 1.73337V2.66671H4C2.89543 2.66671 2 3.56214 2 4.66671V12.6667C2 13.7713 2.89543 14.6667 4 14.6667H12C13.1046 14.6667 14 13.7713 14 12.6667V4.66671C14 3.56214 13.1046 2.66671 12 2.66671H11.0666V1.73337C11.0666 1.51246 10.8875 1.33337 10.6666 1.33337C10.4457 1.33337 10.2666 1.51246 10.2666 1.73337V2.66671H5.73327L5.73327 1.73337ZM12 3.46671H4C3.33726 3.46671 2.8 4.00397 2.8 4.66671V6.00004L13.2 6.00004V4.66671C13.2 4.00397 12.6627 3.46671 12 3.46671ZM2.8 12.6667V6.80004L13.2 6.80004V12.6667C13.2 13.3294 12.6627 13.8667 12 13.8667H4C3.33726 13.8667 2.8 13.3294 2.8 12.6667Z"
      fill="#1F1F1F"
    />
  </svg>,
  'Calendar'
);

export const InfoIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1f1f1f"
    strokeWidth="0.4"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 16.8601 7.13989 20.8 12 20.8ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#5B5C5B"
    />
    <path
      d="M11.25 11.25C11.25 10.8358 11.5858 10.5 12 10.5C12.4142 10.5 12.75 10.8358 12.75 11.25V15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75V11.25Z"
      fill="#5B5C5B"
    />
    <path
      d="M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Info'
);

export const MisUseIcon = createSvgIcon(
  <svg width="16" height="16" viewBox="-2 -2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_426_13849" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016ZM6.28314 5.71725C6.12693 5.56105 5.87367 5.56105 5.71746 5.71725C5.56125 5.87346 5.56125 6.12673 5.71746 6.28294L7.43462 8.0001L5.71746 9.71725C5.56125 9.87346 5.56125 10.1267 5.71746 10.2829C5.87367 10.4391 6.12693 10.4391 6.28314 10.2829L8.0003 8.56578L9.71746 10.2829C9.87367 10.4391 10.1269 10.4391 10.2831 10.2829C10.4394 10.1267 10.4394 9.87346 10.2831 9.71725L8.56599 8.0001L10.2831 6.28294C10.4394 6.12673 10.4394 5.87346 10.2831 5.71725C10.1269 5.56105 9.87367 5.56105 9.71746 5.71725L8.0003 7.43441L6.28314 5.71725Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016ZM6.28314 5.71725C6.12693 5.56105 5.87367 5.56105 5.71746 5.71725C5.56125 5.87346 5.56125 6.12673 5.71746 6.28294L7.43462 8.0001L5.71746 9.71725C5.56125 9.87346 5.56125 10.1267 5.71746 10.2829C5.87367 10.4391 6.12693 10.4391 6.28314 10.2829L8.0003 8.56578L9.71746 10.2829C9.87367 10.4391 10.1269 10.4391 10.2831 10.2829C10.4394 10.1267 10.4394 9.87346 10.2831 9.71725L8.56599 8.0001L10.2831 6.28294C10.4394 6.12673 10.4394 5.87346 10.2831 5.71725C10.1269 5.56105 9.87367 5.56105 9.71746 5.71725L8.0003 7.43441L6.28314 5.71725Z"
      fill="#5B5C5B"
    />
    <path
      d="M6.28314 5.71725L6.99025 5.01015L6.99025 5.01015L6.28314 5.71725ZM5.71746 6.28294L6.42457 5.57583H6.42456L5.71746 6.28294ZM7.43462 8.0001L8.14172 8.7072L8.84883 8.0001L8.14172 7.29299L7.43462 8.0001ZM5.71746 10.2829L6.42457 9.57583L6.42456 9.57583L5.71746 10.2829ZM6.28314 10.2829L5.57604 9.57583L6.28314 10.2829ZM8.0003 8.56578L8.70741 7.85868L8.0003 7.15157L7.29319 7.85868L8.0003 8.56578ZM9.71746 10.2829L10.4246 9.57583L9.71746 10.2829ZM10.2831 9.71725L10.9903 9.01015V9.01015L10.2831 9.71725ZM8.56599 8.0001L7.85888 7.29299L7.15177 8.0001L7.85888 8.7072L8.56599 8.0001ZM10.2831 5.71725L10.9903 5.01015L10.9902 5.01015L10.2831 5.71725ZM9.71746 5.71725L10.4246 6.42436L10.4246 6.42436L9.71746 5.71725ZM8.0003 7.43441L7.29319 8.14152L8.0003 8.84863L8.70741 8.14152L8.0003 7.43441ZM8.00004 15.6668C12.2342 15.6668 15.6667 12.2343 15.6667 8.00016H13.6667C13.6667 11.1298 11.1297 13.6668 8.00004 13.6668V15.6668ZM0.333374 8.00016C0.333374 12.2343 3.76586 15.6668 8.00004 15.6668V13.6668C4.87043 13.6668 2.33337 11.1298 2.33337 8.00016H0.333374ZM8.00004 0.333496C3.76586 0.333496 0.333374 3.76598 0.333374 8.00016H2.33337C2.33337 4.87055 4.87043 2.3335 8.00004 2.3335V0.333496ZM15.6667 8.00016C15.6667 3.76598 12.2342 0.333496 8.00004 0.333496V2.3335C11.1297 2.3335 13.6667 4.87055 13.6667 8.00016H15.6667ZM6.42456 6.42436C6.19025 6.65868 5.81035 6.65868 5.57604 6.42436L6.99025 5.01015C6.44352 4.46342 5.55709 4.46341 5.01035 5.01015L6.42456 6.42436ZM6.42456 5.57583C6.65888 5.81015 6.65888 6.19005 6.42456 6.42436L5.01035 5.01015C4.46362 5.55688 4.46362 6.44331 5.01035 6.99005L6.42456 5.57583ZM8.14172 7.29299L6.42457 5.57583L5.01035 6.99005L6.72751 8.7072L8.14172 7.29299ZM6.42456 10.4244L8.14172 8.7072L6.72751 7.29299L5.01035 9.01015L6.42456 10.4244ZM6.42456 9.57583C6.65888 9.81015 6.65888 10.19 6.42456 10.4244L5.01035 9.01015C4.46362 9.55688 4.46362 10.4433 5.01035 10.99L6.42456 9.57583ZM5.57604 9.57583C5.81035 9.34152 6.19025 9.34152 6.42457 9.57583L5.01035 10.99C5.55709 11.5368 6.44352 11.5368 6.99025 10.99L5.57604 9.57583ZM7.29319 7.85868L5.57604 9.57583L6.99025 10.99L8.70741 9.27289L7.29319 7.85868ZM10.4246 9.57583L8.70741 7.85868L7.29319 9.27289L9.01035 10.99L10.4246 9.57583ZM9.57604 9.57583C9.81035 9.34152 10.1903 9.34152 10.4246 9.57583L9.01035 10.99C9.55709 11.5368 10.4435 11.5368 10.9903 10.99L9.57604 9.57583ZM9.57604 10.4244C9.34172 10.19 9.34172 9.81015 9.57604 9.57583L10.9903 10.99C11.537 10.4433 11.537 9.55688 10.9903 9.01015L9.57604 10.4244ZM7.85888 8.7072L9.57604 10.4244L10.9903 9.01015L9.27309 7.29299L7.85888 8.7072ZM9.57604 5.57583L7.85888 7.29299L9.27309 8.7072L10.9903 6.99005L9.57604 5.57583ZM9.57604 6.42436C9.34172 6.19005 9.34172 5.81015 9.57604 5.57583L10.9903 6.99005C11.537 6.44331 11.537 5.55688 10.9903 5.01015L9.57604 6.42436ZM10.4246 6.42436C10.1902 6.65868 9.81035 6.65867 9.57604 6.42436L10.9902 5.01015C10.4435 4.46342 9.55709 4.46341 9.01035 5.01015L10.4246 6.42436ZM8.70741 8.14152L10.4246 6.42436L9.01035 5.01015L7.29319 6.7273L8.70741 8.14152ZM5.57604 6.42436L7.29319 8.14152L8.70741 6.72731L6.99025 5.01015L5.57604 6.42436Z"
      fill="#5B5C5B"
      mask="url(#path-1-inside-1_426_13849)"
    />
  </svg>,
  'MisUse'
);

export const SearchInputIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7141 13.2801C11.7195 14.1439 10.4208 14.6668 9.00004 14.6668C5.87043 14.6668 3.33337 12.1298 3.33337 9.00016C3.33337 5.87055 5.87043 3.3335 9.00004 3.3335C12.1297 3.3335 14.6667 5.87055 14.6667 9.00016C14.6667 10.421 14.1438 11.7198 13.2798 12.7144L16.5494 15.984C16.7056 16.1402 16.7056 16.3935 16.5494 16.5497C16.3932 16.7059 16.1399 16.7059 15.9837 16.5497L12.7141 13.2801ZM13.8667 9.00016C13.8667 11.6879 11.6878 13.8668 9.00004 13.8668C6.31225 13.8668 4.13337 11.6879 4.13337 9.00016C4.13337 6.31238 6.31225 4.1335 9.00004 4.1335C11.6878 4.1335 13.8667 6.31238 13.8667 9.00016Z"
      fill="#1F1F1F"
    />
  </svg>,
  'SearchInput'
);

export const PaperIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66659 11.1668C6.66659 10.8906 6.89044 10.6668 7.16659 10.6668H12.8333C13.1094 10.6668 13.3333 10.8906 13.3333 11.1668C13.3333 11.4429 13.1094 11.6668 12.8333 11.6668H7.16659C6.89044 11.6668 6.66659 11.4429 6.66659 11.1668Z"
      fill="white"
    />
    <path
      d="M7.16659 13.1668C6.89044 13.1668 6.66659 13.3906 6.66659 13.6668C6.66659 13.9429 6.89044 14.1668 7.16659 14.1668H11.1666C11.4427 14.1668 11.6666 13.9429 11.6666 13.6668C11.6666 13.3906 11.4427 13.1668 11.1666 13.1668H7.16659Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33325 4.16675C3.33325 2.78604 4.45254 1.66675 5.83325 1.66675H10.6311C11.2941 1.66675 11.93 1.93014 12.3988 2.39898L15.9344 5.93452C16.4032 6.40336 16.6666 7.03924 16.6666 7.70228V15.8334C16.6666 17.2141 15.5473 18.3334 14.1666 18.3334H5.83325C4.45254 18.3334 3.33325 17.2141 3.33325 15.8334V4.16675ZM14.1666 17.3334H5.83325C5.00482 17.3334 4.33325 16.6618 4.33325 15.8334V4.16675C4.33325 3.33832 5.00482 2.66675 5.83325 2.66675H10.6311C10.6708 2.66675 10.7105 2.66833 10.7498 2.67146V5.83341C10.7498 6.79991 11.5333 7.58341 12.4998 7.58341H15.6619C15.665 7.62282 15.6666 7.66247 15.6666 7.70228V15.8334C15.6666 16.6618 14.995 17.3334 14.1666 17.3334ZM15.169 6.58342L11.7498 3.16421V5.83341C11.7498 6.24763 12.0856 6.58342 12.4998 6.58342H15.169Z"
      fill="white"
    />
  </svg>,
  'Paper'
);

export const CancelIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.10355 3.39645C3.90829 3.20118 3.59171 3.20118 3.39645 3.39645C3.20118 3.59171 3.20118 3.90829 3.39645 4.10355L9.29298 10.0001L3.39661 15.8964C3.20135 16.0917 3.20135 16.4083 3.39661 16.6036C3.59187 16.7988 3.90845 16.7988 4.10372 16.6036L10.0001 10.7072L15.8964 16.6036C16.0917 16.7988 16.4083 16.7988 16.6036 16.6036C16.7988 16.4083 16.7988 16.0917 16.6036 15.8964L10.7072 10.0001L16.6037 4.10355C16.799 3.90829 16.799 3.59171 16.6037 3.39645C16.4085 3.20118 16.0919 3.20118 15.8966 3.39645L10.0001 9.29298L4.10355 3.39645Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Cancel'
);

export const ListIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.50008 4.99992C2.96032 4.99992 3.33341 4.62682 3.33341 4.16659C3.33341 3.70635 2.96032 3.33325 2.50008 3.33325C2.03984 3.33325 1.66675 3.70635 1.66675 4.16659C1.66675 4.62682 2.03984 4.99992 2.50008 4.99992Z"
      fill="#5B5C5B"
    />
    <path
      d="M2.50008 10.8333C2.96032 10.8333 3.33341 10.4602 3.33341 9.99992C3.33341 9.53968 2.96032 9.16659 2.50008 9.16659C2.03984 9.16659 1.66675 9.53968 1.66675 9.99992C1.66675 10.4602 2.03984 10.8333 2.50008 10.8333Z"
      fill="#5B5C5B"
    />
    <path
      d="M3.33341 15.8333C3.33341 16.2935 2.96032 16.6666 2.50008 16.6666C2.03984 16.6666 1.66675 16.2935 1.66675 15.8333C1.66675 15.373 2.03984 14.9999 2.50008 14.9999C2.96032 14.9999 3.33341 15.373 3.33341 15.8333Z"
      fill="#5B5C5B"
    />
    <path
      d="M5.50008 9.49984C5.22394 9.49984 5.00008 9.72369 5.00008 9.99984C5.00008 10.276 5.22394 10.4998 5.50008 10.4998H17.8334C18.1096 10.4998 18.3334 10.276 18.3334 9.99984C18.3334 9.72369 18.1096 9.49984 17.8334 9.49984H5.50008Z"
      fill="#5B5C5B"
    />
    <path
      d="M5.00008 4.1665C5.00008 3.89036 5.22394 3.6665 5.50008 3.6665H17.8334C18.1096 3.6665 18.3334 3.89036 18.3334 4.1665C18.3334 4.44265 18.1096 4.6665 17.8334 4.6665H5.50008C5.22394 4.6665 5.00008 4.44265 5.00008 4.1665Z"
      fill="#5B5C5B"
    />
    <path
      d="M5.50008 15.3332C5.22394 15.3332 5.00008 15.557 5.00008 15.8332C5.00008 16.1093 5.22394 16.3332 5.50008 16.3332H17.8334C18.1096 16.3332 18.3334 16.1093 18.3334 15.8332C18.3334 15.557 18.1096 15.3332 17.8334 15.3332H5.50008Z"
      fill="#5B5C5B"
    />
  </svg>,
  'List'
);

export const NextIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3075 9.49996C16.2983 9.48969 16.2888 9.47962 16.2789 9.46975L11.3236 4.5203C11.1281 4.32504 11.1281 4.00846 11.3236 3.81319C11.5191 3.61793 11.836 3.61793 12.0315 3.81319L16.9868 8.76264C17.6711 9.44606 17.6711 10.5541 16.9868 11.2375L12.0315 16.187C11.836 16.3822 11.5191 16.3822 11.3236 16.187C11.1281 15.9917 11.1281 15.6751 11.3236 15.4799L16.2789 10.5304C16.2888 10.5205 16.2985 10.5103 16.3077 10.5L3.00059 10.5C2.72412 10.5 2.5 10.2761 2.5 9.99996C2.5 9.72382 2.72412 9.49996 3.00059 9.49996L16.3075 9.49996Z"
      fill="white"
    />
  </svg>,
  'Next'
);

export const UpIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4983 7.85619C10.2141 7.6036 9.7859 7.6036 9.50173 7.85619L2.83219 13.7847C2.6258 13.9681 2.30976 13.9495 2.1263 13.7432C1.94284 13.5368 1.96143 13.2207 2.16782 13.0373L8.83737 7.10878C9.50042 6.5194 10.4996 6.5194 11.1626 7.10878L17.8322 13.0373C18.0386 13.2207 18.0572 13.5368 17.8737 13.7432C17.6903 13.9495 17.3742 13.9681 17.1678 13.7847L10.4983 7.85619Z"
      fill="white"
    />
  </svg>,
  'Up'
);

export const EmptyIcon = createSvgIcon(
  <svg width="52" height="43" viewBox="0 0 52 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M51.8221 16.7292C42.9124 7.81948 30.4991 4.57113 18.9907 6.93778L24.8377 12.7848C32.8889 12.3904 41.0562 15.2211 47.1816 21.3697L51.8221 16.7292ZM42.5412 26.0102C39.548 23.0171 35.9517 21.0681 32.1233 20.0704L40.3137 28.2609L42.5412 26.0102ZM3.12017 2.92376L10.2433 10.0005C6.83257 11.6711 3.63063 13.8985 0.799927 16.7292L5.41722 21.3697C8.29432 18.4926 11.6123 16.358 15.1623 14.9426L20.3596 20.14C16.6008 21.1145 13.0276 23.0635 10.0809 26.0102V26.0334L14.6982 30.6507C17.8537 27.4952 21.9838 25.9174 26.1138 25.871L42.518 42.2519L45.4647 39.3284L6.11329 0.000244141L3.12017 2.92376ZM19.3619 35.2912L26.3226 42.2519L33.2834 35.2912C29.455 31.4396 23.2135 31.4396 19.3619 35.2912Z"
      fill="#F94B50"
    />
  </svg>,
  'Empty'
);

export const FirstEndIcon = createSvgIcon(
  <svg width="10" height="14" viewBox="-3 -2 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.28456 6.60136C1.08249 6.82869 1.08249 7.17127 1.28456 7.3986L6.02735 12.7342C6.17412 12.8993 6.15925 13.1522 5.99413 13.2989C5.82902 13.4457 5.57619 13.4308 5.42942 13.2657L0.686635 7.93009C0.215132 7.39965 0.215133 6.60031 0.686635 6.06987L5.42942 0.734234C5.57619 0.569121 5.82902 0.554249 5.99413 0.701017C6.15925 0.847783 6.17412 1.10061 6.02735 1.26573L1.28456 6.60136Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.6179 6.60136C4.41582 6.82869 4.41582 7.17127 4.6179 7.3986L9.36068 12.7342C9.50745 12.8993 9.49258 13.1522 9.32747 13.2989C9.16235 13.4457 8.90952 13.4308 8.76276 13.2657L4.01997 7.93009C3.54847 7.39965 3.54847 6.60031 4.01997 6.06987L8.76276 0.734234C8.90952 0.569121 9.16235 0.554249 9.32747 0.701017C9.49258 0.847783 9.50745 1.10061 9.36068 1.26573L4.6179 6.60136Z"
      fill="#5B5C5B"
    />
  </svg>,
  'FirstEnd'
);

export const PrevArrowIcon = createSvgIcon(
  <svg width="7" height="14" viewBox="-2 -1 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.28554 6.60128C1.08347 6.82861 1.08347 7.17119 1.28554 7.39852L6.02833 12.7342C6.17509 12.8993 6.16022 13.1521 5.99511 13.2989C5.83 13.4456 5.57717 13.4308 5.4304 13.2656L0.687611 7.93001C0.216108 7.39957 0.216109 6.60023 0.687612 6.06979L5.4304 0.734152C5.57717 0.569039 5.83 0.554167 5.99511 0.700935C6.16022 0.847702 6.17509 1.10053 6.02833 1.26564L1.28554 6.60128Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Prev'
);

export const LastEndIcon = createSvgIcon(
  <svg width="10" height="14" viewBox="-3 -2 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.51115 6.60148C8.71322 6.82881 8.71322 7.17139 8.51115 7.39872L3.76836 12.7344C3.62159 12.8995 3.63646 13.1523 3.80158 13.2991C3.96669 13.4458 4.21952 13.431 4.36629 13.2658L9.10907 7.93021C9.58058 7.39977 9.58058 6.60043 9.10907 6.06999L4.36629 0.734356C4.21952 0.569243 3.96669 0.554371 3.80158 0.701139C3.63646 0.847906 3.62159 1.10073 3.76836 1.26585L8.51115 6.60148Z"
      fill="#5B5C5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17781 6.60148C5.37989 6.82881 5.37989 7.17139 5.17781 7.39872L0.435025 12.7344C0.288258 12.8995 0.30313 13.1523 0.468243 13.2991C0.633356 13.4458 0.886185 13.431 1.03295 13.2658L5.77574 7.93021C6.24724 7.39977 6.24724 6.60043 5.77574 6.06999L1.03295 0.734356C0.886185 0.569243 0.633356 0.554371 0.468243 0.701139C0.30313 0.847906 0.288258 1.10073 0.435025 1.26585L5.17781 6.60148Z"
      fill="#5B5C5B"
    />
  </svg>,
  'LastEnd'
);

export const NextArrowIcon = createSvgIcon(
  <svg width="7" height="14" viewBox="-2 -1 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.38243 6.60128C5.5845 6.82861 5.5845 7.17119 5.38243 7.39852L0.639642 12.7342C0.492875 12.8993 0.507747 13.1521 0.67286 13.2989C0.837974 13.4456 1.0908 13.4308 1.23757 13.2656L5.98036 7.93001C6.45186 7.39957 6.45186 6.60023 5.98036 6.06979L1.23757 0.734152C1.0908 0.569039 0.837974 0.554167 0.67286 0.700935C0.507747 0.847702 0.492875 1.10053 0.639642 1.26564L5.38243 6.60128Z"
      fill="#5B5C5B"
    />
  </svg>,
  'Next'
);
